import React, { FC } from 'react'
import { Avatar, AvatarProps } from '@mui/material'

const EvtAvatar: FC<AvatarProps> = ({ children, ...props }) => {
    return <Avatar {...props}>{children}</Avatar>
}

export default EvtAvatar
